import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { BLOGS_API } from '../api/blog-api'
import { BlogPostId, BlogPostsInterface } from '../types/blog-posts-interface'

export const useSchedulePostApi = () => {
  const { fetcher: postFetcher } = useFetch<RequestMethodsEnum.post, BlogPostsInterface>({
    method: RequestMethodsEnum.post,
  })

  return {
    schedulePost: (id: BlogPostId, data: Pick<BlogPostsInterface, 'activatedAt'>) =>
      postFetcher(`${BLOGS_API}/posts/${id}/schedule`, data),
  }
}
